import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';

import { ModuleDeclaration } from '../ModuleDeclaration';

import SocialSetup from './SocialSetup/SocialSetup';


const SocialContainer = (props: any): JSX.Element => {
  const element = withAuthenticationRequired(Outlet)(props) as JSX.Element;
  return element;
};

const SocialRouteProperties: ModuleDeclaration = {
  routeProps: {
    path: '/social',
    element: <SocialContainer />,
    children: [{ index: true, element: <SocialSetup /> }],
  },
  name: 'Social',
  isHidden: true,
};

export default SocialRouteProperties;
